<template>
  <div :class="$style.uploadDocumentsPopUp">
    <b :class="$style.documents">Documents</b>
    <div :class="$style.frameParent">
      <div :class="$style.schoolTranscriptsParent">
        <div :class="$style.frameLabel">School Transcripts</div>
        <div v-if="!schoolTranscript" :class="$style.frameWrapper">
          <label :class="$style.vectorWrapper">
            <input
              type="file"
              @change="handleFileUpload($event, 'schoolTranscript')"
              hidden
            />
            <img
              :class="$style.vectorIcon"
              alt=""
              src="/static/img/upload.svg"
            />
          </label>
        </div>
        <div v-else :class="$style.viewWrapper">
          <button
            type="button"
            @click="viewFile(schoolTranscript)"
            :class="$style.view"
          >
            View
          </button>
        </div>
      </div>
      <div :class="$style.schoolTranscriptsParent">
        <div :class="$style.frameLabel">
          Proof of Identity (e.g., Driver’s License, Passport)
        </div>
        <div v-if="!proofOfIdentity" :class="$style.frameWrapper">
          <label :class="$style.vectorWrapper">
            <input
              type="file"
              @change="handleFileUpload($event, 'proofOfIdentity')"
              hidden
            />
            <img
              :class="$style.vectorIcon"
              alt=""
              src="/static/img/upload.svg"
            />
          </label>
        </div>
        <div v-else :class="$style.viewWrapper">
          <button
            type="button"
            @click="viewFile(proofOfIdentity)"
            :class="$style.view"
          >
            View
          </button>
        </div>
      </div>
      <div :class="$style.schoolTranscriptsParent">
        <div :class="$style.frameLabel">
          Proof of Income (e.g., Pay Stub, Tax Return) if applicable
        </div>
        <div v-if="!proofOfIncome" :class="$style.frameWrapper">
          <label :class="$style.vectorWrapper">
            <input
              type="file"
              @change="handleFileUpload($event, 'proofOfIncome')"
              hidden
            />
            <img
              :class="$style.vectorIcon"
              alt=""
              src="/static/img/upload.svg"
            />
          </label>
        </div>
        <div v-else :class="$style.viewWrapper">
          <button
            type="button"
            @click="viewFile(proofOfIncome)"
            :class="$style.view"
          >
            View
          </button>
        </div>
      </div>
    </div>
    <div :class="$style.uploadDocumentsPopUpInner">
      <div :class="$style.saveWrapper">
        <b :class="$style.save">Save</b>
      </div>
    </div>
    <img
      :class="$style.closeIcon"
      alt=""
      src="/static/img/grey-x.svg"
      @click="closeModal"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      schoolTranscript: null,
      proofOfIdentity: null,
      proofOfIncome: null,
    };
  },
  methods: {
    handleFileUpload(event, type) {
      const file = event.target.files[0];
      if (file) {
        this[type] = file;
      }
    },
    viewFile(file) {
      if (file) {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
});
</script>

<style module scoped>
.documents {
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.view {
  position: relative;
  line-height: 25px;
}
.viewWrapper {
  width: 76px;
  border-radius: 5px;
  background-color: #3171e2;
  height: 29px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  color: #fff;
}
.schoolTranscriptsParent {
  align-self: stretch;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  cursor: pointer;
}
.frameLabel {
  flex: 1;
  position: relative;
}
.vectorIcon {
  width: 16px;
  position: relative;
  height: 15.6px;
}
.vectorWrapper {
  border-radius: 5px;
  background-color: #3171e2;
  height: 29px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 30px;
  box-sizing: border-box;
}
.frameWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
.frameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
}
.save {
  position: relative;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.saveWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.uploadDocumentsPopUpInner {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 2;
  text-align: center;
  color: #fff;
}
.closeIcon {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.uploadDocumentsPopUp {
  width: 700px;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
